import { render, staticRenderFns } from "./AccountContactUsage.vue?vue&type=template&id=78fffdf7&scoped=true"
import script from "./AccountContactUsage.vue?vue&type=script&lang=js"
export * from "./AccountContactUsage.vue?vue&type=script&lang=js"
import style0 from "./AccountContactUsage.vue?vue&type=style&index=0&id=78fffdf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fffdf7",
  null
  
)

export default component.exports